import { render, staticRenderFns } from "./ConfirmPage.vue?vue&type=template&id=2e2c9ce6&scoped=true&"
import script from "./ConfirmPage.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPage.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmPage.vue?vue&type=style&index=0&id=2e2c9ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c9ce6",
  null
  
)

/* custom blocks */
import block0 from "./ConfirmPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports